
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licitaciones"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caracter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"normatividad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objeto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroConvocatoria"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaConvocatoria"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaInicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaTermino"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plazo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anticipoMaterial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anticipoInicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calendario"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idLicitacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventoTexto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaHora"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lugar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"obras"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idLicitacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idObra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"obra"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idTipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idSubtipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descripcion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subtipo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descripcion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ejercicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":764}};
    doc.loc.source = {"body":"query {\n  licitaciones {\n    id\n    tipo\n    numero\n    caracter\n    normatividad\n    objeto\n    numeroConvocatoria\n    fechaConvocatoria\n    fechaInicio\n    fechaTermino\n    plazo\n    anticipoMaterial\n    anticipoInicio\n    estatus\n    calendario {\n      id\n      idLicitacion\n      evento\n      eventoTexto\n      fechaHora\n      lugar\n      createdAt\n      updatedAt\n    }\n    obras {\n      id\n      idLicitacion\n      idObra\n      obra {\n        id\n        idTipo\n        idSubtipo\n        tipo {\n          id\n          descripcion\n          color\n        }\n        subtipo {\n          id\n          descripcion\n          color\n        }\n        ejercicio\n        clave\n        meta\n      }\n      createdAt\n      updatedAt\n    }\n    createdAt\n    updatedAt\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
